import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    Dialog,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Stack,
    TextField,
    Typography
} from "@mui/material";

import { DatePicker } from '@mui/x-date-pickers';

import Localisation3 from "../Common/Localisation3";

export default function RepresentedDetailsDialog(props) {
    //  console.log("RepresentedDetailsDialog", props);
    const [state, setState] = useState({ ...props.state.params.prx, new_loc: false });
    const [updatedState, setUpdatedState] = useState({});
    const handleClose = () => {
        props.onClose();
    };
    const handleChange = (event) => {
        console.log("handlechange")
        setUpdatedState({ ...updatedState, [event.target.name]: event.target.value, changes: true });
    };
    const handleSubmit = () => {

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updatedState)
        };
        fetch("/api/f124d7c7175a4f6988aee8afb3cb6eaa/" + props.state.params.prx.u, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        window.location.reload();
                        break;

                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };

    const [disabled, setDisabled] = useState(true);


    return (
        <Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
            <DialogTitle id="add-user-dialog"><Typography variant="h5" gutterBottom>Informations du représenté</Typography></DialogTitle>
            <DialogContent dividers>
                {props.state.params.prx.t === 1 && (
                    <Stack spacing={1}>
                        <Box justifyContent={"space-between"} alignItems={"center"}>
                            <Box>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        row
                                        aria-label="g"
                                        name="g"
                                        defaultValue={state.g}
                                        onChange={handleChange}
                                        dense
                                        value={state.g}
                                    >
                                        <FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
                                        <FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <Box>
                                <TextField
                                    id="fn"
                                    name="fn"
                                    variant="outlined"
                                    style={{
                                        marginLeft: 0,
                                        marginRight: 0,
                                    }}
                                    placeholder="Prénom"
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    value={updatedState.fn ? updatedState.fn : state.fn}
                                    onChange={handleChange}
                                />
                            </Box>

                        </Box>
                        <TextField
                            id="ln"
                            name="ln"
                            variant="outlined"
                            style={{
                                marginLeft: 0,
                                marginRight: 10,
                            }}
                            placeholder="Nom"
                            fullWidth
                            margin="dense"
                            size="small"
                            value={updatedState.ln ? updatedState.ln : state.ln}
                            onChange={handleChange}
                        />
                        <DatePicker
                            inputFormat="dd/MM/yyyy"
                            disableFuture
                            openTo="month"
                            views={['year', 'month', 'day']}
                            value={updatedState.bd ? updatedState.bd : state.bd}
                            onChange={(date) => {
                                handleChange({
                                    target: { name: "bd", value: date.toISOString() },
                                })
                            }}
                            renderInput={(params) => <TextField size="small" placeholder="Date de naissance (jj/mm/aaaa)" style="max-width: 150px;" {...params} />}
                        />
                        <TextField
                            id="bp"
                            name="bp"
                            variant="outlined"
                            style={{
                                marginLeft: 0,
                                marginRight: 10,
                            }}
                            placeholder="Lieu de naissance"
                            fullWidth
                            margin="dense"
                            size="small"
                            value={updatedState.bp ? updatedState.bp : state.bp}
                            onChange={handleChange}
                        />
                        <Typography variant="h5">Adresse</Typography>
                        <Localisation3 upperState={state} mode="PRX" upperSendLoc={handleChange} />
                        

                    </Stack>
                )}
                {props.state.params.prx.t === 2 && (
                    <Stack>
                        <Typography variant="h5">Raison sociale de la société</Typography>
                        <TextField
                            id="rs"
                            name="rs"
                            variant="outlined"
                            style={{
                                marginLeft: 0,
                                marginRight: 10,
                            }}
                            placeholder="Raison sociale"
                            fullWidth
                            margin="dense"
                            size="small"
                            value={updatedState.rs ? updatedState.rs : state.rs}
                            onChange={handleChange}
                        />
                        <Typography variant="h5">Identification de la société</Typography>
                        <TextField
                            id="s"
                            name="s"
                            variant="outlined"
                            style={{
                                marginLeft: 0,
                                marginRight: 10,
                            }}
                            placeholder="Siret, ..."
                            fullWidth
                            margin="dense"
                            size="small"
                            value={updatedState.s ? updatedState.s : state.s}
                            onChange={handleChange}
                        />
                        <Typography variant="h5">Adresse</Typography>
                        {state.a && <div>{state.a}</div>}
                        <Localisation3 upperState={state} mode="PRX" upperSendLoc={handleChange} />
                    </Stack>
                )}
            </DialogContent>
            <DialogActions>
                <Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%;">
                    <Box>
                        <Button variant="contained" onClick={handleClose} >
                            Annuler
                        </Button>
                    </Box>
                    <Box>
                        <Button variant="contained" onClick={handleSubmit} disabled={!updatedState.changes}>
                            Valider
                        </Button>
                    </Box>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
